<template>
    <div class="input-block">
        <label class="label">{{ labelName }}</label>
        <div class="datepicker-block" :class="labelName.toLowerCase()">
            <datepicker
                class="datepicker-input"
                :value="date"
                :disabledDates="disabledDates"
                @selected="dateSelected"
            />
            <img
                src="../../../../../../assets/main_images/top-bottom-icon.png"
                class="top-bottom-arrow"
                alt="arrow-icon"
            />
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
    name: 'DatePickerField',
    props: ['labelName', 'initialDate', 'disableDatesProp'],
    components: {
        Datepicker,
    },
    data() {
        return {
            disabledDates: {
                to: new Date(),
            },
            date: new Date(),
        }
    },
    watch: {
        $props: {
            handler() {
                this.checkProps()
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.checkProps()
    },
    methods: {
        checkProps() {
            if (this.disableDatesProp) {
                this.disabledDates = this.disableDatesProp
            }

            if (this.initialDate) {
                this.date = new Date(this.initialDate)
            }
        },
        dateSelected(data) {
            this.$emit('input', data)
            if (this.labelName === 'Departing') {
                this.$emit('change', data)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/scss/global-styles';

* {
    box-sizing: border-box;
}

.input-block {
    padding: 10px 20px;

    &:hover,
    &:active {
        background: rgba(192, 192, 201, 0.12) 0% 0% no-repeat padding-box;
        border-radius: 6px;
    }

    /*flex-basis: 25%;*/

    .label {
        font-family: 'Gilroy-Regular', sans-serif;
        font-size: 12px;
        line-height: 14px;
        text-align: left;
        color: $mainTextBlueColor;
    }

    .datepicker-block {
        position: relative;

        .top-bottom-arrow {
            width: 11px;
            max-height: 10px;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);

            &.top-arrow {
                transform: rotate(180deg);
            }
        }
    }

    >>> .datepicker-input {
        &.vdp-datepicker {
            input {
                background: transparent;
                border: none;
                color: $mainTextBlueColor;
                padding: 10px 10px 10px 0;
                outline: none;
                font-family: 'Gilroy-SemiBold', sans-serif;
                font-size: 18px;
                line-height: 22px;
                text-align: left;
                width: 100%;
                cursor: pointer;
            }

            .vdp-datepicker__calendar {
                background: #f5f5f6;
                border-radius: 7px;
                color: $mainTextBlueColor;
                font-family: 'Gilroy-Regular', sans-serif;
                padding: 5px 10px 10px;

                header {
                    .prev {
                        &:after {
                            border-right: 10px solid $mainTextBlueColor;
                        }

                        &.disabled {
                            &:after {
                                border-right: 10px solid rgba(192, 192, 201, 1);
                            }
                        }

                        &:hover {
                            &:after {
                                border-right: 10px solid $mainTextBlueColor;
                            }
                        }
                    }

                    .prev,
                    .next {
                        &:hover {
                            background-color: transparent;
                        }
                    }

                    .next {
                        &:after {
                            border-left: 10px solid $mainTextBlueColor;
                        }

                        &.disabled {
                            &:after {
                                border-left: 10px solid rgba(255, 255, 255, 0.33);
                            }
                        }

                        &:hover {
                            &:after {
                                border-left: 10px solid $mainTextBlueColor;
                            }
                        }
                    }

                    //for month change
                    .day__month_btn,
                    .month__year_btn {
                        font-family: 'Gilroy-Medium', sans-serif;
                        cursor: pointer;
                    }
                }

                .cell {
                    &.disabled,
                    &.blank {
                        &:hover {
                            background: none;
                            transform: unset;
                            border: none;
                            border-radius: unset;
                            line-height: 3.29em;
                            cursor: default;
                        }
                    }

                    &.day {
                        font-size: 13px;
                        color: $blueTextFixedColor;
                        font-family: 'Gilroy-Medium', sans-serif;

                        &:hover {
                            border: none;
                            background: transparent
                                linear-gradient(180deg, #fec183 0%, #fea880 17%, #fe6b7a 54%, #ff1572 100%) 0% 0%
                                no-repeat padding-box;
                            border-radius: 50%;
                            cursor: pointer;
                        }

                        &.disabled {
                            color: #bdbdcb;
                        }

                        &.disabled,
                        &.blank {
                            &:hover {
                                background: none;
                                transform: unset;
                                border: none;
                                border-radius: unset;
                                line-height: 3.29em;
                                cursor: default;
                            }
                        }

                        &.selected {
                            color: #ffffff;
                            background: linear-gradient(180deg, #fec183 0%, #fea880 17%, #fe6b7a 54%, #ff1572 100%) 0%
                                0% no-repeat padding-box;
                            border-radius: 50%;
                        }

                        &.blank {
                        }

                        &.weekend {
                            &.sat {
                            }

                            &.sun {
                            }
                        }
                    }

                    // for month select
                    &.month {
                        font-size: 13px;
                        color: $blueTextFixedColor;
                        font-family: 'Gilroy-Medium', sans-serif;

                        &.selected {
                            color: #ffffff;
                            background: linear-gradient(180deg, #fec183 0%, #fea880 17%, #fe6b7a 54%, #ff1572 100%) 0%
                                0% no-repeat padding-box;
                            border-radius: 50%;
                        }

                        &:hover {
                            border: none;
                            background: transparent
                                linear-gradient(180deg, #fec183 0%, #fea880 17%, #fe6b7a 54%, #ff1572 100%) 0% 0%
                                no-repeat padding-box;
                            border-radius: 50%;
                            cursor: pointer;
                        }

                        &.disabled {
                            color: #bdbdcb;
                        }

                        &.disabled,
                        &.blank {
                            &:hover {
                                background: none;
                                transform: unset;
                                border: none;
                                border-radius: unset;
                                line-height: 3.29em;
                                cursor: default;
                            }
                        }
                    }

                    //for year select

                    &.year {
                        font-size: 13px;
                        color: $blueTextFixedColor;
                        font-family: 'Gilroy-Medium', sans-serif;

                        &.selected {
                            color: #ffffff;
                            background: linear-gradient(180deg, #fec183 0%, #fea880 17%, #fe6b7a 54%, #ff1572 100%) 0%
                                0% no-repeat padding-box;
                            border-radius: 50%;
                        }

                        &:hover {
                            border: none;
                            background: transparent
                                linear-gradient(180deg, #fec183 0%, #fea880 17%, #fe6b7a 54%, #ff1572 100%) 0% 0%
                                no-repeat padding-box;
                            border-radius: 50%;
                            cursor: pointer;
                        }

                        &.disabled {
                            color: #bdbdcb;
                        }

                        &.disabled,
                        &.blank {
                            &:hover {
                                background: none;
                                transform: unset;
                                border: none;
                                border-radius: unset;
                                line-height: 3.29em;
                                cursor: default;
                            }
                        }
                    }
                }
            }
        }
    }
}

@media (max-width: 768px) {
    .input-block {
        /*max-width: unset;*/
        padding: 10px 20px;
        /*flex-basis: unset;*/

        .label {
            font-size: 14px;
            line-height: 17px;
        }

        >>> .datepicker-input {
            &.vdp-datepicker {
                input {
                    font-size: 16px;
                    line-height: 20px;
                }

                .vdp-datepicker__calendar {
                    .cell {
                        &.day {
                            font-size: 16px;
                        }
                    }
                }
            }
        }

        .datepicker-block.return {
            >>> .datepicker-input {
                .vdp-datepicker__calendar {
                    left: -150px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/shared/forms_entities/form-fields/date-picker-field.vue